// extracted by mini-css-extract-plugin
module.exports = {"camera":"AddConsignmentDocument_camera__ytX8M","imgContainer":"AddConsignmentDocument_imgContainer__cC2uO","img":"AddConsignmentDocument_img__hHeFT"};